/** Shared SeeVi design tokens — aligned with profile / browse jobs pages */
export const FONT_FAMILY = "'Poppins', sans-serif";

export const ORANGE_HEADER = "rgb(255, 137, 96)";
export const PRIMARY = "#756DE9";
export const PRIMARY_DARK = "#6159d1";
export const PRIMARY_LIGHT = "rgba(117, 109, 233, 0.12)";
export const PRIMARY_BORDER = "rgba(117, 109, 233, 0.28)";
export const PRIMARY_SHADOW = "rgba(117, 109, 233, 0.2)";

export const ORANGE_ACCENT = "#FF8960";
export const ORANGE_LIGHT = "#FFF2EE";

export const BG_PAGE = "#ffffff";
export const BG_SUBTLE = "#F8F8FA";
export const BG_CARD = "#ffffff";

export const TEXT_PRIMARY = "#1F2235";
export const TEXT_SECONDARY = "#757575";
export const TEXT_MUTED = "#ADADAD";

export const BORDER_LIGHT = "#E6E4FE";
export const BORDER_DEFAULT = "rgba(0, 0, 0, 0.08)";

export const RADIUS_CARD = "10px";
export const RADIUS_BUTTON = "8px";
export const RADIUS_PILL = "99px";

/** @deprecated Use PRIMARY — kept for gradual migration */
export const ACCENT = ORANGE_ACCENT;
